import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryReturnedItemsReport'
import Component from 'components/Reports/InventoryReturnedItemsReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryReturnedItemsReport })(Component)
